import { http } from '../http'
import { URL } from './_constant'

/**
 * 集体土地项目-安置监审-列表
 */
export function API_RESETTLE_AUDIT_LIST(data?: BasicPageReq) {
  return http.post<ApiResettleAudit.ListRes>(URL.LIST, data)
}

/**
 * 集体土地项目-安置监审-全部
 */
export function API_RESETTLE_AUDIT_ALL(data?: BasicPageReq) {
  return http.post<ApiResettleAudit.Item[]>(URL.LIST, data)
}

/**
 * 集体土地项目-安置监审-详情
 */
export function API_RESETTLE_AUDIT_DETAIL(id: string) {
  return http.post<ApiResettleAudit.Item>(URL.DETAIL, { id })
}

/**
 * 集体土地项目-安置监审-新增
 */
export function API_RESETTLE_AUDIT_ADD(data: ApiResettleAudit.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 集体土地项目-安置监审-删除
 */
export function API_RESETTLE_AUDIT_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  集体土地项目-安置监审-编辑
 */
export function API_RESETTLE_AUDIT_EDIT(data: BasicUpdateOneReq<ApiResettleAudit.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  集体土地项目-安置监审-禁用
 */
export function API_RESETTLE_AUDIT_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 集体土地项目-安置监审-启用
 */
export function API_RESETTLE_AUDIT_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 集体土地项目-安置监审-排序
 */
export function API_RESETTLE_AUDIT_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 集体土地项目-安置监审-审核列表
 */
export function API_RESETTLE_AUDIT_REVIEW_LIST(data?: BasicPageReq) {
  return http.post<ApiResettleAudit.ListRes>(URL.REVIEW_LIST, data)
}
